export default (itemId, connectItemId) => {
  window.dispatchEvent(
    new CustomEvent('itemMoveEnd', {
      detail: { id: itemId, connectItemId },
    })
  );
};
